<template>
  <!-- 社群授权配置 -->
  <div>
    <el-form
      ref="form"
      label-width="150px"
      label-position="left"
    >
      <SpCardContent title="客户联系API授权设置">
        <div>
          <el-form-item label="KEY：">
            <el-input
              v-model="form.app_key"
              disabled
              style="width: 300px"
            />
          </el-form-item>
          <el-form-item label="SECRET：">
            <el-input
              v-model="form.app_secret"
              disabled
              style="width: 300px"
            />
          </el-form-item>
        </div>
      </SpCardContent>

      <SpCardContent title="营销中心开发配置">
        <div>
          <el-form-item label="请求URL：">
            <el-input
              v-model="form.external_base_uri"
              disabled
              style="width: 300px"
            />
          </el-form-item>
          <el-form-item label="KEY：">
            <el-input
              v-model="form.external_app_key"
              disabled
              style="width: 300px"
            />
          </el-form-item>
          <el-form-item label="SECRET：">
            <el-input
              v-model="form.external_app_secret"
              disabled
              style="width: 300px"
            />
          </el-form-item>
        </div>
      </SpCardContent>
    </el-form>
  </div>
</template>
<script>
import { getDeveloper } from '@/api/setting/devSettings.js'

export default {
  data () {
    return {
      form: {
        app_key: '',
        app_secret: '',
        external_base_uri: '',
        external_app_key: '',
        external_app_secret: ''
      }
    }
  },
  mounted () {
    this.getSetting()
  },
  methods: {
    // 获取设置数据
    async getSetting () {
      const data = await getDeveloper()
      if (data) {
        this.form = data
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wechat-top {
  margin-bottom: 35px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.box-card {
  margin-bottom: 20px;
}
</style>
